import CustodianTransactionMatching from "../../features/custodiantransactionmatching";

const CustodianTransactionMatchingPage = () => <CustodianTransactionMatching />

export default CustodianTransactionMatchingPage;